import { ApiHelper } from '../../ApiHelper';

export interface ReviewerEmailChoice {
    signalKey: string;
    name: string;
    emailAddress: string | null;
    pullRequests: Array<{
        taskListId: number;
        taskId: number;
        prId: number;
    }>;
}

interface ReviewerEmailResolutionResponse {
    reviewers: Array<{
        signalKey: string;
        displayName: string;
        emailAddress: string | null;
    }>;
}

export interface ReviewerEmailResolutionResult {
    reviewers: ReviewerEmailChoice[];
    lookupFailed: boolean;
}

export function getSignedInUserDisplayName(): string {
    const user = window.user as {
        name?: string | null;
        emailAddress?: string | null;
    } | null | undefined;
    const name = user?.name?.trim();
    if (name) return name;

    const emailName = user?.emailAddress?.trim().split('@')[0];
    return emailName || 'PR Guardian user';
}

export async function resolveReviewerEmailAddresses(
    serviceName: string,
    reviewers: ReviewerEmailChoice[],
): Promise<ReviewerEmailResolutionResult> {
    const missing = reviewers.filter(reviewer => !reviewer.emailAddress);
    if (missing.length === 0) {
        return { reviewers, lookupFailed: false };
    }

    try {
        const response = await ApiHelper<ReviewerEmailResolutionResponse>(
            `/api/service/${encodeURIComponent(serviceName)}/agenttasks/revieweremails/resolve`,
            'POST',
            {
                reviewers: missing.map(reviewer => ({
                    signalKey: reviewer.signalKey,
                    displayName: reviewer.name,
                    pullRequests: reviewer.pullRequests,
                })),
            },
        );
        const resolvedBySignalKey = new Map(
            response.reviewers.map(reviewer => [
                reviewer.signalKey,
                reviewer.emailAddress?.trim() || null,
            ]),
        );
        return {
            reviewers: reviewers.map(reviewer => ({
                ...reviewer,
                emailAddress: reviewer.emailAddress
                    || resolvedBySignalKey.get(reviewer.signalKey)
                    || null,
            })),
            lookupFailed: false,
        };
    } catch {
        return { reviewers, lookupFailed: true };
    }
}
